import storeModule from '../../store-module'
import { defineStore } from 'pinia'

const url = 'dashboard/sale-channels'

export default defineStore('dashboard-sale-channels',
  storeModule.createStoreModule('dashboard-sale-channels', {
    fetchListURL: url,
    fetchFiltersURL: `${url}/filters`
  })
)
